import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import uniqueId from 'lodash.uniqueid';
// import cn from 'classnames';
import { Button } from '../../../components';

import TemplateItemRow from './TemplateItemRow';

export default class TemplateItemModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		template: PropTypes.object,
		onSave: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired
	}

	static defaultProps = {
		isOpen: false
	}

	state = {
		isEditting: false,
		itemsToDelete: [],
		templateItems: [],
		showAddForm: false,
		isSaving: false
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.template) {
			if (nextProps.template.appointment_template_item) {
				this.setState({
					templateItems: nextProps.template.appointment_template_item
				});
			} else { // user might be updating a new template
				this.setState({ templateItems: [] });
			}
		}
	}

	handleSave = () => {
		this.setState({ isSaving: true });
		this.props.onSave(this.state.templateItems, this.state.itemsToDelete);
	}

	handleDeleteTemplateItem = (templateItem) => {
		this.setState((currState) => {
			return {
				templateItems: currState.templateItems.filter(ti => ti.id != templateItem.id),
				itemsToDelete: [...currState.itemsToDelete, templateItem]
			};
		});
	}

	handleToggleEditting = () => {
		this.setState(currState => ({ isEditting: !currState.isEditting }));
	}

	handleShowAddForm = () => {
		this.setState({ showAddForm: true, isEditting: true });
	}

	handleRowEditCancel = () => {
		this.setState({ showAddForm: false, isEditting: false });
	}

	handleRowEditDone = (templateItem, startTime, endTime) => {
		this.setState((currState) => {
			if (templateItem.id) {
				templateItem.start_time = startTime;
				templateItem.end_time = endTime;
				return {
					showAddForm: false,
					isEditting: false
				};
			} else {
				return {
					templateItems: [...currState.templateItems, { id: uniqueId('n-'), start_time: startTime, end_time: endTime }],
					showAddForm: false,
					isEditting: false
				};
			}
		});
	}

	render() {
		const { isOpen, onCancel } = this.props;
		const { isEditting, templateItems, showAddForm, isSaving } = this.state;
		return (
			<Modal isOpen={isOpen} contentLabel="Template Schedule" className="modal-dialog modal-lg">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onCancel}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								Template Schedule{' '}
								<small>Set the start and end times for a particular day of the week.</small>
							</h3>
						</div>
					</div>
					<div className="modal-body">
						<div className="text-right">
							<Button
								title="Add"
								label="plus"
								info
								onClick={this.handleShowAddForm}
								disabled={showAddForm}
							/>
						</div>
						<table className="table table-striped">
							<thead>
								<tr>
									<th>Start Day</th>
									<th>Start Time</th>
									<th>End Day</th>
									<th colSpan="2">End Time</th>
								</tr>
							</thead>
							<tbody>
								{showAddForm && (
									<TemplateItemRow
										templateItem={{ start_time: 0, end_time: 0 }}
										onCancel={this.handleRowEditCancel}
										onDone={this.handleRowEditDone}
										disable={isEditting}
									/>
								)}
								{templateItems.map(templateItem => (
									<TemplateItemRow
										key={templateItem.id}
										templateItem={templateItem}
										onDelete={this.handleDeleteTemplateItem}
										onEdit={this.handleToggleEditting}
										onCancel={this.handleToggleEditting}
										onDone={this.handleRowEditDone}
										disable={isEditting}
									/>
								))}
							</tbody>
						</table>
					</div>
					<div className="modal-footer">
						<div className="pull-right">
							<Button
								title="Cancel"
								large
								onClick={onCancel}
								disabled={isEditting || isSaving}
							/>
							<Button
								title="Save"
								onClick={this.handleSave}
								disabled={isEditting || isSaving}
								large
								primary
								className="ml"
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
